import * as React from "react";

export const CloseSVG = (props) => {
    return (
        <svg viewBox="0 0 28 30" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path d="M.871 0l27.092 28.054-.72.695L.152.695z" />
            <path d="M0 28.511L27.057.424l.72.693L.72 29.205z" />
        </svg>
    );
};
